import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { UserButtonsLine } from "aw-user-buttons-line";
import { getLast7days, getTodayDate } from "aw-date-functions";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import { DashboardTypes, MachineConected } from "aw-consts";
import DataCircle from "../components/DataComponent/DataCircle.component";
import { getRandomNumber } from "aw-generic-functions";
import { AWGrid, TableData } from "aw-grid";
import CharD3, { charData } from "../components/CharProductionComponent/charD3.component";
import PercentageCircle from "../components/PercentageComponent/PercentageCircle.component";
import { downloadFile, generateCSVProduction } from "../utils/libs/filesFunc";
import { format } from "date-fns";
import CombinedCircleCard from "../components/CombinedCircleCardComponent/CombinedCircleCard.component";
import { useTheme } from "../utils/contexts/ThemeContext";


const ProductionPage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();
    const [iniDate, setIniDate] = useState(getLast7days())
    const [finDate, setFinDate] = useState(getTodayDate())
    const [loadingData, setLoadingData] = useState(false)
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);
    const theme = useTheme()

    const tableHeaders = [t('NSerie'), t('Model'), t('MaterialCode'), t('Start'), t('Time')]
    const tableBody: TableData[] = [
        { item: [1, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [2, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [3, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [4, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [5, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [6, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [7, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [8, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true },
        { item: [9, '12VAD856YSU25', 'Table 00598FD', '251DD56E', '26/11/2025 16:54', '03:42 h'], active: true }]



    const getCharData = (): charData[] => {
        const charData: charData[] = []
        const now = new Date()
        now.setDate(now.getDate() - 6)
        for (let i = 0; i < 7; i++) {
            charData.push({ date: `${now.getDate()}/${now.getMonth() + 1}`, numItems: getRandomNumber(0, 100) })
            now.setDate(now.getDate() + 1)
        }

        return charData
    }

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        context.setState(t('Production'));
    }, [context, t]);

    const onChangeDates = (e: any) => {
        if (e.target.name === "iniDate") {
            setIniDate(e.target.value)
        } else if (e.target.name === "finDate") {
            setFinDate(e.target.value)
        }
    }

    const reloadButtonClick = () => {
        setLoadingData(true)
        setTimeout(() => setLoadingData(false), 500)
    }

    const downloardData = () => {
        const titles = tableHeaders.join(';')
        downloadFile(generateCSVProduction(tableBody, `${titles}\n`), `${format(new Date(), "ddMMyyyyHHmm")}_${t('Data')}.csv`)
    }


    return (
        <>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <UserButtonsLine downloardData={downloardData} role={user.role} connected={MachineConected.Conected} defaultIni={iniDate}
                        defaultFin={finDate} onChangeDates={onChangeDates} onChangeSelect={() => { return false }} onClickReload={reloadButtonClick} options={[]}
                        selected={{ label: '', value: '' }} DashboardType={DashboardTypes.Company} changeView={() => null} rounded='rounded-1' classNameSecondary='btn-Custom btn-IDGrey'
                        classNameSuccess='btn-Custom btn-IDGreen' containerColor='var(--background-secondary)' dark={theme.theme === 'dark' ? true : false} />
                </div>
            </div>
            <div className='row border-0 gx-2 mx-2 mt-1' style={{ maxWidth: '100%', height: isWideScreen ? '350px' : '1200px' }}>
                <div className='col-lg-3 col-12'>
                    <CombinedCircleCard refresh={false} title={t('Productivity')} circleType="progress" percentage={getRandomNumber(60, 90)} strokeWidth={12} color={1} />
                </div>
                <div className='col-lg-3 col-12'>
                    <CombinedCircleCard refresh={loadingData} title={t('WorkingHours')} data={getRandomNumber(100, 300)} circleType="info" color={2} units='h' />
                </div>
                <div className='col-lg-3 col-12'>
                    <CombinedCircleCard refresh={false} title={t('AvgProductsDay')} circleType="info" data={getRandomNumber(20, 80)} strokeWidth={12} color={4} />
                </div>
                <div className='col-lg-3 col-12'>
                    <CombinedCircleCard refresh={false} title={t('ProductErros')} circleType="info" data={getRandomNumber(20, 80)} strokeWidth={12} color={3} />
                </div>
            </div>
            <div className='row border-0 mb-3 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-6 px-1 mt-2'>
                    <AWGrid loading={loadingData} noDataText={t('NoData')} onDeleteClick={() => null} onEditClick={() => null} tableData={tableBody}
                        tableHeaders={tableHeaders} bgColor="var(--background-secondary)" textColor="var(--text-primary)" title={t('ManufacturedItems')} manage={false} gridStyle="gridsStyle" />
                </div>
                <div className='col-12 col-md-6 mt-1 p-1'>
                    <CharD3 dataChar={getCharData()} loading={loadingData} capture={false} title={t('ItemsForDay')} setPNGChar={() => null} />
                </div>
            </div>

        </>
    )
}

export default ProductionPage